import { getFeatureFlags } from '@noths/polaris-client-feature-flags';
import type { IncomingMessage } from 'http';

import {
  GraphQLFetchWithAbort,
  HighCommissionBoosting,
  SearchListingServingConfig,
} from './featureFlags';

export const getFeatureFlagsWithMatchers = (req: IncomingMessage) => {
  return getFeatureFlags(req, {
    collapseFlagNames: [
      { newName: GraphQLFetchWithAbort.NAME, oldNameMatcher: /^graphql_fetch_with_abort/m },
      {
        newName: SearchListingServingConfig.NAME,
        oldNameMatcher: /^search_listing_serving_config/m,
      },
      {
        newName: HighCommissionBoosting.NAME,
        oldNameMatcher: /^plp_hc_boosting/m,
      },
    ],
  });
};
